import { useEffect } from "react";
import { setTitlePage } from "../../Functions";

const Maintenance = () => {

  useEffect(() => {
    setTitlePage('Sitio en Mantenimiento')
  }, []);
  return (
    <div className="card p-5 text-gray-600" style={{paddingTop: '150px'}}>
      <div className="row px-3">
        <div className="col-12 p-5">
          <article style={{display: 'block', textAlign: 'left', maxWidth: '650px', margin: '0 auto'}}>
              <h1 className="title-mantenimiento text-primaryamsm">¡Estaremos de vuelta pronto!</h1>
              <div>
                  <p className="text-mantenimiento" style={{paddingTop: '20px'}}>
                    Disculpe las molestias pero estamos realizando algunas tareas de mantenimiento en este momento. Si lo necesita, siempre puede <a href="mailto:contacto@amsm.cl">contactarnos</a>; de lo contrario, ¡volveremos a estar en línea en breve!
                  </p>
                  <p className="text-mantenimiento">- Equipo AMSM</p>
              </div>
          </article>
        </div>
      </div>
    </div>
  );
}

export default Maintenance;